<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils.ts';
import { ArrowLeftIcon } from '@radix-icons/vue';
import type { WithClassAsProps } from './interface';
import { useCarousel } from './useCarousel';

const props = defineProps<WithClassAsProps>();

const { orientation, canScrollPrev, scrollPrev } = useCarousel();
</script>

<template>
  <Button
    :disabled="!canScrollPrev"
    :class="
      cn(
        'touch-manipulation absolute h-8 w-8 rounded-full p-0 bg-primary',
        orientation === 'horizontal'
          ? 'left-4 top-1/2 -translate-y-1/2'
          : 'top-4 left-1/2 -translate-x-1/2 rotate-90',
        props.class,
      )
    "
    variant="outline"
    @click="scrollPrev"
  >
    <slot>
      <ArrowLeftIcon class="h-4 w-4 text-current" />
      <span class="sr-only">Previous Slide</span>
    </slot>
  </Button>
</template>
